import { useEffect, useRef, useState } from "react";
import Button from "@amzn/meridian/esm/components/button";
import closeSmallTokens from "@amzn/meridian-tokens/base/icon/close-small";
import Column from "@amzn/meridian/esm/components/column";
import Icon from "@amzn/meridian/esm/components/icon";
import Popover from "@amzn/meridian/esm/components/popover";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Textarea from "@amzn/meridian/esm/components/textarea";
import Theme from "@amzn/meridian/esm/components/theme/theme";
import aimsTheme from "../../styles/meridian-theme-aims.json";
import FeedbackPopoverTop from "../../images/feedback_popover_top.svg";

const InMeetingExpFeedbackPopover = ({ onSubmit, onClose }) => {
  const popoverRef = useRef();
  const [feedbackComment, setFeedbackComment] = useState("");
  const [isRefReady, setIsRefReady] = useState(false);

  useEffect(() => {
    if (popoverRef.current) {
      setIsRefReady(true);
    }
  }, []);

  const handleSubmit = () => {
    onSubmit(feedbackComment);
    onClose();
  };

  const handleClose = () => {
    onSubmit(undefined);
    onClose();
  };

  return (
    <Column alignmentHorizontal="center">
      <Row ref={popoverRef} />
      {isRefReady && <Theme palette={aimsTheme}>
        <Popover
          open={true}
          minWidth="292px"
          anchorNode={popoverRef.current}
          onClose={handleClose}
          position="top"
          indicatorArrow={false}
          spacingInset="none"
        >
          <Column heights={["20%", "60%", "20%"]} height="235px" spacing="none">
            <div
              style={{
                background: `url(${FeedbackPopoverTop}) no-repeat center/cover`,
                width: "100%",
              }}
            >
              <Row widths={["10%", "70%", "20%"]} alignmentVertical="bottom" height="50px">
                <div />
                <Text type="h100">Share feedback</Text>
                <Button type="icon" onClick={handleClose}>
                  <Icon tokens={closeSmallTokens} />
                </Button>
              </Row>
            </div>
            <Row alignmentHorizontal="center">
              <Textarea
                value={feedbackComment}
                onChange={setFeedbackComment}
                placeholder="Enter comment"
                error={false}
                width="230px"
                rows={3}
                size="small"
              />
            </Row>
            <Row alignmentHorizontal="end" spacingInset="none 500 500 none">
              <Button type="primary" size="small" minWidth="90px" onClick={handleSubmit}>
                Submit
              </Button>
            </Row>
          </Column>
        </Popover>
      </Theme>}
    </Column>
  );
};

export default InMeetingExpFeedbackPopover;
